import React, {useMemo, useState, useEffect} from "react";
import {Grid, Typography, Button} from "@mui/material";
import AutocompleteEmail from "../autocomplete-email";
import { useSelector } from "react-redux";
import { updateUsageReportRecipients, getUsageReportRecipients } from "../../shared/api";
import {USER_SUPERADMIN} from "../../shared/constants";

const CustomerReportingDefaultEmailList = () => {
    const [selectedRecipients, updateSelectedRecipients] = useState([]);

    const ifwUserDataImmutable = useSelector((state) =>
        state.dataStore.getIn(["ifwUsers"])
    );

    const ifwEmailList = useMemo(() => {
        const dataSet = ifwUserDataImmutable.toJS();
        return dataSet
            .filter((item) => {
               return item.role === USER_SUPERADMIN;
            })
            .map(item => {
                return item.email;
            });
    }, [ifwUserDataImmutable]);

    const token = useSelector((state) => state.dataStore.getIn(["loginInfo", "authorizationToken"]));

    const loadRecipientList = async () => {
        const recipients = await getUsageReportRecipients(token);
        updateSelectedRecipients(recipients.userEmails !== null ? recipients.userEmails : []);
    };

    useEffect(() => {
        loadRecipientList();
    },[]);

    const handleSave = async () => {
        await updateUsageReportRecipients(selectedRecipients, token);
    };

    const handleChange = (event, newValue) => {
        updateSelectedRecipients(newValue);
    }

    return <Grid className={"email-recipients-list"} container spacing={3}>
        <Grid item xs={12}>
            <Typography component={"label"} variant={"label"}>
                Email recipients for scheduled monthly usage report (sent on the 1st of every month for the preceeding month)
            </Typography>
        </Grid>
        <Grid item xs={12}>
            <AutocompleteEmail
                value={selectedRecipients}
                data={ifwEmailList}
                onChange={handleChange}
            />
        </Grid>
        <Grid item xs={12}>
            <Button disabled={selectedRecipients === null || selectedRecipients.length === 0} color={"primary"} variant={"contained"} onClick={handleSave}>Save</Button>
        </Grid>
    </Grid>
};

export default CustomerReportingDefaultEmailList;
